exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".boarding-control{align-items:start}.boarding-control .boarding-category__title{font-size:.75em;font-weight:600;margin-bottom:5px;padding:10px 0 0 40px}body[dir=rtl] .boarding-control .boarding-category__title {\n  padding: 10px 40px 0 0;\n}\n", ""]);

// exports
